export const getFeedbackLoading = state => state.statistics.loading.feedback
export const getStatistics = state => state.statistics
